var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBuildingLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 1.5H12C11.6 1.5 11.22 1.66 10.94 1.94C10.66 2.22 10.5 2.6 10.5 3V10.5H3C2.6 10.5 2.22 10.66 1.94 10.94C1.66 11.22 1.5 11.6 1.5 12V22.5H22.5V3C22.5 2.6 22.34 2.22 22.06 1.94C21.78 1.66 21.4 1.5 21 1.5ZM6.75 21V15.75H9.75V21H6.75ZM21 21H11.25V15C11.25 14.8 11.17 14.61 11.03 14.47C10.89 14.33 10.7 14.25 10.5 14.25H6C5.8 14.25 5.61 14.33 5.47 14.47C5.33 14.61 5.25 14.8 5.25 15V21H3V12H12V3H21V21Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6H13.5V7.5H15V6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 6H18V7.5H19.5V6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15 10.5H13.5V12H15V10.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 10.5H18V12H19.5V10.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 15H13.5V16.5H15V15Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 15H18V16.5H19.5V15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBuildingLocation);
export default __webpack_public_path__ + "static/media/ic-building-location.38d59fff907621f4fd49c4dfb0da55ad.svg";
export { ForwardRef as ReactComponent };